var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crosshair"},[_c('tooltip',{attrs:{"tooltip":_vm.tooltip}},[_vm._t("default",function(){return [(_vm.tooltip.isActive)?_c('div',[_vm._v(" "+_vm._s(_vm.tooltip.item)+" ")]):_vm._e()]},{"tooltip":_vm.tooltip})],2),_c('div',{ref:"chart",style:({ height: `${_vm.height}px` })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }